import React from 'react';
import { Box, Divider, Stack, ThemeProvider } from '@mui/material';
import { theme } from '../../../../theme/theme';
import PropTypes from 'prop-types';
import MetricTile from './MetricTile';

const MetricBox = (props) => {
	const { metrices, data, updateReplInstock } = props;

	return (
		<ThemeProvider theme={theme}>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					margin: '24px 16px',
				}}>
				<Stack
					sx={{
						width: '100%',
						display: 'flex',
						justifyContent: 'space-between',
						border: '1px solid #E3E4E5',
						padding: '16px 24px',
						borderRadius: '8px',
					}}
					direction="row"
					divider={
						<Divider
							sx={{
								margin: '16px ',
							}}
							orientation="vertical"
							flexItem
						/>
					}
					spacing={2}>
					{metrices?.metrics?.map((item) => {
						return (
							<MetricTile
								item={item}
								key={item.id}
								data={data}
								updateReplInstock={updateReplInstock}
							/>
						);
					})}
				</Stack>
				{/* </Box> */}
			</Box>
		</ThemeProvider>
	);
};

MetricBox.propTypes = {
	metrices: PropTypes.object,
	data: PropTypes.object,
	updateReplInstock: PropTypes.func,
};

export default MetricBox;
